import { createSlice, Reducer, Slice } from "@reduxjs/toolkit";

import { getDefaultSlicersForForecastEntryApp } from "../../shared/functions";
import { ForecastReviewDropdownModel, ForecastReviewSelectedSlicerModel } from "../../models/TradeAndPromoPlanning/ForecastReviewSlicer.model";
import ForecastReviewTabSlice from "../../models/Redux/ForecastReviewTabSlice.model";
import { FORECAST_REVIEW_TAB_ID } from "../../shared/constants";

const defaultSlicers: ForecastReviewSelectedSlicerModel = getDefaultSlicersForForecastEntryApp(FORECAST_REVIEW_TAB_ID);

const initialState: ForecastReviewTabSlice = {
    tempSelectedSlicers: defaultSlicers,
    selectedSlicers: defaultSlicers,
    slicers: {
        sku_brands: [],
        sku_sub_brands: [],
        sku_volume_sizes: [],
        years: []
    }
};

const forecastReviewTabSlice: Slice = createSlice({
    name: "forecastReviewTab",
    initialState,
    reducers: {
        setSlicers: (state: ForecastReviewTabSlice, action: { payload: ForecastReviewDropdownModel }) => {
            state.slicers = action.payload;
        },
        setTempSlicers: (state: ForecastReviewTabSlice, action: { payload: ForecastReviewSelectedSlicerModel }) => {
            state.tempSelectedSlicers = action.payload;
        },
        setSelectedSlicers: (state: ForecastReviewTabSlice, action: { payload: ForecastReviewSelectedSlicerModel }) => {
            state.selectedSlicers = action.payload;
        },
        resetSelectedSlicers: (state: ForecastReviewTabSlice, action) => {
            state.tempSelectedSlicers = structuredClone(defaultSlicers);
            state.selectedSlicers = structuredClone(defaultSlicers);
        }
    }
});

export const forecastReviewTabActions = forecastReviewTabSlice.actions;

export default forecastReviewTabSlice.reducer as Reducer<ForecastReviewTabSlice>;
